import { Container } from '@mui/material';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { useApp } from '../../contexts/AppContext';
import { ResourceProvider } from '../../contexts/ResourceContext';
import withAuthentication from '../../hocs/withAuthentication';
import Analysis from './Analysis';
import Form from './Form';
import History from './History';


const Page: React.FC = () => {
  const navigate = useNavigate();
  const { updateBreadcrumbs, updateActions } = useApp();


  return (
    <ResourceProvider>
      <Container>
        <Routes>
          <Route element={<History />} path="/" />
          <Route element={<Analysis withReviews={false} title="Analysis" />} path="/analysis" />
          <Route element={<Form />} path="/create" />
        </Routes>
      </Container>
    </ResourceProvider>

  );
}

export default withAuthentication(Page);
